import axios from 'axios'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const downloadFile: any = (params: any, tokens: any) => {
  return axios
    .get(`${APIEndPoints.fileDownload}${params}`, {
      headers: sitConfig(tokens).headers,
      responseType: 'arraybuffer',
      timeout: 30000,
    })
    .then((resp) => {
      return responseParser(resp)
    })
}

export { downloadFile }
